import Profile1 from "../assets/img/team/profile-picture-1.jpg";
import Profile2 from "../assets/img/team/profile-picture-2.jpg";
import Profile3 from "../assets/img/team/profile-picture-3.jpg";
import Profile4 from "../assets/img/team/profile-picture-4.jpg";

export default [
  {
    id: 1,
    image: Profile1,
    firstName: "Thomas",
    lastName: "Shelby",
    email: "thomas@thisgmailac.com",
    phone: "786-987-0987",
    position: "Manager",
    dateCreated: "January 20, 1921",
    workingToday: true,
    jobsCompleted: 14,
  },
  {
    id: 2,
    image: Profile2,
    firstName: "Arthur ",
    lastName: "Shelby",
    position: "Counterperson",
    phone: "305-007-5678",
    email: "arthur@thisgmailac.com",
    dateCreated: "March 20, 1917",
    workingToday: true,
    jobsCompleted: 8,
  },
  {
    id: 3,
    image: Profile3,
    firstName: "Alian",
    lastName: "Morales",
    position: "Mechanic",
    email: "alianm@thisgmailac.com",
    phone: "546-877-0980",
    dateCreated: "March 20, 1912",
    workingToday: true,
    jobsCompleted: 4,
    vehicles: [
      { id: 2, make: "Toyota", model: "Corolla", year: 2000, color: "Gray" },
    ],
  },
  {
    id: 4,
    image: Profile4,
    firstName: "Julio",
    lastName: "Santiago",
    position: "Mechanic",
    email: "john@thisgmailac.com",
    phone: "876-127-0000",
    dateCreated: "December 20, 1924",
    workingToday: false,
    jobsCompleted: 1,
    vehicles: [
      { id: 1, make: "Nissan", model: "Altima", year: 2021, color: "Green" },
    ],
  },
  // {
  //   id: 5,
  //   image: Profile1,
  //   firstName: "Thomas",
  //   lastName: "Shelby",
  //   email: "thomas@thisgmailac.com",
  //   phone: "786-987-0987",
  //   position: "Mechanic",
  //   dateCreated: "January 20, 1921",
  //   workingToday: true,
  //   jobsCompleted: 6,
  //   vehicles: [
  //     { id: 1, make: "Ford", model: "Mustang", year: 1994, color: "Black" },
  //     { id: 2, make: "Toyota", model: "Corolla", year: 2000, color: "Gray" },
  //   ],
  // },
  // {
  //   id: 6,
  //   image: Profile2,
  //   firstName: "Arthur ",
  //   lastName: "Shelby",
  //   position: "Mechanic",
  //   phone: "305-007-5678",
  //   email: "arthur@thisgmailac.com",
  //   dateCreated: "March 20, 1917",
  //   workingToday: true,
  //   jobsCompleted: 0,
  //   vehicles: [
  //     { id: 2, make: "Toyota", model: "Corolla", year: 2000, color: "Gray" },
  //   ],
  // },
  // {
  //   id: 7,
  //   image: Profile3,
  //   firstName: "Luis Alberto",
  //   lastName: "Bradeas",
  //   position: "Mechanic",
  //   email: "polly@thisgmailac.com",
  //   phone: "546-877-0980",
  //   dateCreated: "March 20, 1912",
  //   workingToday: false,
  //   jobsCompleted: 0,
  //   vehicles: [
  //     { id: 1, make: "Nissan", model: "Altima", year: 2021, color: "Green" },
  //   ],
  // },
  // {
  //   id: 8,
  //   image: Profile4,
  //   firstName: "Julio",
  //   lastName: "Santiago",
  //   position: "Mechanic",
  //   email: "john@thisgmailac.com",
  //   phone: "876-127-0000",
  //   dateCreated: "December 20, 1924",
  //   workingToday: false,
  //   jobsCompleted: 0,
  //   vehicles: [
  //     { id: 1, make: "Toyota", model: "Corolla", year: 2000, color: "Gray" },
  //   ],
];
